var GENERIC_FONT_FAMILIES = new Set([
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong',
]);
var GOOGLE_FONT_WEIGHTS = '300;400;500;600;700;800';
var sanitizeFontFamily = function (fontFamily) {
    return (fontFamily || '').trim();
};
var stripQuotes = function (fontFamily) {
    return fontFamily.replace(/^['"]|['"]$/g, '');
};
export var normalizeFontFamily = function (fontFamily) {
    var sanitizedFontFamily = sanitizeFontFamily(fontFamily);
    if (!sanitizedFontFamily) {
        return 'Roboto, sans-serif';
    }
    if (sanitizedFontFamily.includes(',')) {
        return sanitizedFontFamily;
    }
    var normalizedFontFamily = stripQuotes(sanitizedFontFamily);
    var isGenericFamily = GENERIC_FONT_FAMILIES.has(normalizedFontFamily.toLowerCase());
    var shouldQuote = /\s/.test(normalizedFontFamily);
    var cssFontFamily = shouldQuote ? "\"".concat(normalizedFontFamily, "\"") : normalizedFontFamily;
    return isGenericFamily ? cssFontFamily : "".concat(cssFontFamily, ", sans-serif");
};
export var getFontStylesheetHref = function (fontFamily) {
    var sanitizedFontFamily = sanitizeFontFamily(fontFamily);
    if (!sanitizedFontFamily) {
        return null;
    }
    var primaryFontFamily = stripQuotes(sanitizedFontFamily
        .split(',')[0]
        .trim());
    if (!primaryFontFamily || GENERIC_FONT_FAMILIES.has(primaryFontFamily.toLowerCase())) {
        return null;
    }
    var encodedFontFamily = encodeURIComponent(primaryFontFamily).replace(/%20/g, '+');
    return "https://fonts.googleapis.com/css2?family=".concat(encodedFontFamily, ":wght@").concat(GOOGLE_FONT_WEIGHTS, "&display=swap");
};
